import React from 'react'

const SvgAbdomenFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.273 3a20.317 20.317 0 00-.234 1.8c-.167 1.986-.016 3.816.29 5.809.164.948.507 2.91.556 3.172l.062.329c.284 1.514.596 3.179.887 5.09.088.577.175 1.176.258 1.8H2.91c.086-.623.178-1.222.272-1.8.261-1.595.548-3.03.816-4.374l.204-1.03c.16-.87.499-2.728.563-3.203.268-1.877.384-3.725.196-5.793-.052-.58-.129-1.179-.233-1.8h14.545zm-7.272 14.4a.905.905 0 00.909-.9c0-.497-.407-.9-.91-.9a.905.905 0 00-.908.9c0 .497.407.9.909.9z'
    />
  </svg>
)

export default SvgAbdomenFilled
